import { Component, Input, OnInit } from '@angular/core';
import { CmSettingsService, PortalCoreFeature } from '@ats/cm/core';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'div[cm-key-val], cm-key-val',
    templateUrl: './key-val.component.html',
    styleUrls: ['./key-val.component.scss'],
    standalone: false
})
export class CmKeyValComponent implements OnInit {
	@Input() boolean: boolean;
	@Input() alert: string;
	@Input() type: 'info' | 'warn' | 'error' | 'danger' | 'success' = 'info';
	@Input() error: boolean = false;
	@Input() downloadUrl: string;
	@Input() downloadTargetWindow: '_blank' | '_self' | '_parent' | '_top' = '_self';
	isBool: boolean = false;
	readonly locFeature: PortalCoreFeature;

	constructor(private settings: CmSettingsService) {
		this.locFeature = this.settings.portalCoreFeature;
	}

	ngOnInit() {
		this.isBool = this.boolean === false || this.boolean === true;
	}
}
